import Uploader from './Uploader.vue'

Uploader.install = function (Vue) {
  Vue.component(Uploader.name, Uploader)
}

export default Uploader
